import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supplemental-listing',
  templateUrl: './supplemental-listing.component.html',
  styleUrls: ['./supplemental-listing.component.scss']
})
export class SupplementalListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
